<!--
 * @Author: Belief liang.huang@rockynet.onaliyun.com
 * @Date: 2024-09-20 15:47:21
 * @LastEditors: Belief liang.huang@rockynet.onaliyun.com
 * @LastEditTime: 2025-11-13 14:14:43
 * @FilePath: /mall-wap-vue/src/views/mine/question/detail/components/Invioce.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="question">
    <div class="item">
      1. 关于澳洲税务发票 (Tax Invoice)
      <div>
        澳洲企业销售商品通常提供符合 Australian Taxation Office (ATO) 要求的 Tax Invoice。发票包含卖家的 ABN (Australian Business Number)、商品描述、交易日期以及 GST 明细等法定信息。
      </div>
    </div>
    <div class="item">
      2. 关于商品价格与 GST (消费税)
      <div>
        除非另有说明，商品价格通常已包含 10% 的 GST。若商品符合免税条件 (GST-free)，发票将相应注明。
      </div>
    </div>
    <div class="item">
      3. 关于发票获取方式
      <div>
        订单交易完成后，您可以联系 APP 在线客服获取电子税务发票。
      </div>
    </div>
    <div class="item">
      4. 关于发票调整与退款 (Adjustment Notes)
      <div>
        若发生退货、金额更正或取消交易，我们将根据 ATO 规定为您提供 Adjustment Note（调整通知单），作为税务扣减或补收的正式依据。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    backClick() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.question {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 22px;
  padding: 10px 15px 15px;
  border-top: 1px solid #eee;
}
.item {
  padding-top: 5px;
  /* text-indent: 25px; */
}
.item_blod {
  font-weight: 500;
}
</style>
